import { useEffect, useState } from "react";
import CommonFormHeading from "../../CommonUtils/CommonFormHeading";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import * as bie from "react-bootstrap";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { useSelector } from "react-redux";
import { getDistricts } from "../../Reducers/AffiliationCommonservice";
import * as Yup from "yup";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import Swal from "sweetalert2";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import { FaCheck } from "react-icons/fa";

const AfflGovt_CourseAdding = () => {
  const districtmst = useSelector(
    (state) => state?.commonMastersReducer?.DistList
  );

  const acYear = sessionStorage.getItem("ac_year");
  const [CourseDetails, SetCourseDetails] = useState([]);
  const [showcourses, setshowcourses] = useState(false);
  const [courseeerrmsg, setcourseeerrmsg] = useState(false);

  const [ConfirmDetails, SetConfirmDetails] = useState([]);
  const [showconfirm, setshowconfirm] = useState(false);
  const [confirmerrmsg, setconfirmerrmsg] = useState(false);
  const [header, setheader] = useState("");
  const [collcode, setcollcode] = useState("");
  const [ReportDetails, SetReportDetails] = useState([])
  const [showreport, setshowreport] = useState(false);
  const [reporterrmsg, setreporterrmsg] = useState(false);
  const [fieldsdata, setfieldsdata] = useState([]);
  const [isAlreadySubmitted, setIsAlreadySubmitted] = useState(false);
  const CourseAddingvalidation = Yup.object({
    instAddress: Yup.string().required(ERROR_MSG).nullable(),
    instDistCode: Yup.string().required(ERROR_MSG).nullable(),
    instStatus: Yup.string().required(ERROR_MSG).nullable(),
    instMinority: Yup.string().required(ERROR_MSG).nullable(),
    govtPacCourses: Yup.array().of(
      Yup.object().shape({
        afflType: Yup.string().required(ERROR_MSG).nullable(),
      })
    ),
  });


  const Courseaddingformik = useFormik({

    enableReinitialize: true,
    initialValues: {
      instAddress: fieldsdata[0]?.inst_address || "",
      instDistCode: fieldsdata[0]?.inst_dist_code || "",
      instStatus: fieldsdata[0]?.inst_status || "",
      instMinority: fieldsdata[0]?.inst_minority || "",
      collCode: parseInt(collcode),

      govtPacCourses:
        ConfirmDetails?.map((item) => ({

          courseCatId: parseInt(item?.course_cat_id),
          courseId: parseInt(item?.course_id),
          mediumCode: parseInt(item?.medium_code),
          regSelf: item?.reg_self,
          finalSanctionIntake: parseInt(item?.final_sanction_intake),
          afflType: "",
          courseGroupCode: parseInt(item?.course_group_code),

        })),
    },
    validationSchema: CourseAddingvalidation,
    onSubmit: (values) => {
      Swal.fire({
        text: "Are you sure you want to submit?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, submit it!",
        cancelButtonText: "No, cancel!",
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const url = `${config.url.API_URL}saveGovtPacCoursesdetails`;

          values.instDistCode = parseInt(values.instDistCode);

          CommonAxiosPost(url, values).then((res) => {
            if (res?.data?.scode === "01") {
              successAlert2(res?.data?.sdesc);
              setshowcourses(true)
              GetCourseDetails();

            } else {
              failureAlert(res?.data?.sdesc);
            }
          });
        } else {
          console.log("Submission canceled");
        }
      });
    },
  });



  function GetCourseDetails() {
    let url = config.url.API_URL + "getGovtPacCollegeDetails";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        SetCourseDetails(res?.data?.getGovtPacCollegeDetails);
        setshowcourses(true);
        setcourseeerrmsg(false);
        setshowconfirm(false);
        setshowreport(false)
        setconfirmerrmsg(false);
        setreporterrmsg(false)
      } else {
        SetCourseDetails([]);
        setshowcourses(false);
        setcourseeerrmsg(true);
        setshowreport(false)
        setshowconfirm(false);
        setconfirmerrmsg(false);
        setreporterrmsg(false)
      }
    });
  }
  useEffect(() => {
    GetCourseDetails();
    getDistricts();
  }, []);
  function GetConfirmDetails(collcodee) {

    let url = config.url.API_URL + `getGovtPacInstDetails/${collcodee}/${acYear}`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data) {

        const dataa = res?.data?.instRes[0];
        Courseaddingformik?.setFieldValue(`instAddress`, dataa?.inst_address);
        Courseaddingformik?.setFieldValue(`instDistCode`, dataa?.inst_dist_code);
        Courseaddingformik?.setFieldValue(`instStatus`, dataa?.inst_status?.toString() ?? '');
        Courseaddingformik?.setFieldValue(`instMinority`, dataa?.inst_minority?.toString());
        setheader(`Adding Courses For ${res?.data?.instRes[0]?.inst_name}`);
        SetConfirmDetails(res?.data?.coursesRes);
        setfieldsdata(res?.data?.instRes);
        setshowconfirm(true);
        setshowreport(false)
        setconfirmerrmsg(false);
        setshowcourses(false);
        setcourseeerrmsg(false);
        setreporterrmsg(false)
      } else {
        SetConfirmDetails([]);
        setshowconfirm(false);
        setconfirmerrmsg(true);
        setshowreport(false)
        setshowcourses(false);
        setcourseeerrmsg(false);
        setreporterrmsg(false)
      }
    });
  }


  function GetReportDetails(collcodee) {

    let url = config.url.API_URL + `getGovtPacCoursesReport/${collcodee}/${acYear}`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.status === true) {
        SetReportDetails(res?.data?.getGovtPacCoursesReport);
        setshowreport(true)
        setreporterrmsg(false)
        setshowconfirm(false);
        setconfirmerrmsg(false);
        setshowcourses(false);
        setheader(`Added Courses For ${res?.data?.getGovtPacCoursesReport[0]?.inst_name}`);
        setcourseeerrmsg(false);
      } else {
        SetReportDetails([]);
        setshowreport(false)
        setshowconfirm(false);
        setreporterrmsg(true)
        setconfirmerrmsg(false);
        setshowcourses(false);
        setcourseeerrmsg(false);
      }
    });
  }

  const CourseColumns = [
    {
      Header: "Sl.no",
      accessor: (row, index) => index + 1,
    },
    {
      Header: "College Code",
      accessor: "coll_code",
    },
    {
      Header: "College Name",
      accessor: "inst_name",
      Cell: ({ row }) => (
        <div style={{ textAlign: 'left' }}>{row?.values?.inst_name}</div>
      ),
    },
    {
      Header: "College Nature",
      accessor: "coll_nature_name",
      Cell: ({ row }) => (
        <div style={{ textAlign: 'left' }}>{row?.values?.coll_nature_name}</div>
      ),
    },
    {
      Header: "Confirm Courses",
      accessor: (row) => {
        if (row.button === "Already Submitted") {

          return (
            <button type="button"
              style={{
                fontSize: "15px",
                color: "green",
                cursor: "pointer",
              }}
              onClick={() => {
                setIsAlreadySubmitted(true)
                setcollcode(row?.coll_code);
                GetConfirmDetails(row?.coll_code)
              }}
            >
              <FaCheck />  Already Submitted
            </button>
          );
        } else {

          return (
            <button
              type="button"
              // className="btn btn-primary rounded btn-sm"
              className="btn btn-primary btn-sm d-block mx-auto"
              onClick={() => {
                setIsAlreadySubmitted(false)

                GetConfirmDetails(row?.coll_code);
                setcollcode(row?.coll_code);
              }}
            >
              Confirm
            </button>
          );
        }
      },
    },
    {
      Header: "Report for Submitted Courses",
      accessor: (row) => {
        return row.report === "Not Submitted" ? (
          "Not Submitted"
        ) : (
          <button type="button" class="btn btn-success rounded"
            onClick={() => {
              GetReportDetails(row?.coll_code)

            }}>
            Report
          </button>
        );
      },
    },
  ];
  const ConformColumns = [
    {
      Header: "Sl.no",
      accessor: (row, index) => index + 1,

    },
    {
      Header: "Academic Program Type",
      accessor: "course_group_desc",
      Cell: ({ row }) => <div className="text-left">{row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'center' }}>-</b>}</div>

    },
    {
      Header: "	Course /Program",
      accessor: "single_program",
      Cell: ({ row }) => <div className="text-left">{row?.values?.single_program ? row?.values?.single_program : <b style={{ textAlign: 'center' }}>-</b>}</div>

    },
    {
      Header: "Medium",
      accessor: "name",
    },
    {
      Header: "Regular/Self-Financed",
      accessor: "reg_self",
      Cell: ({ row }) => <div className="text-left">{row?.values?.reg_self ? row?.values?.reg_self : <b style={{ textAlign: 'center' }}>-</b>}</div>

    },

    {
      Header: "Nature of Affiliation being Accorded",
      accessor: (row, index) => {
        return (
          <div style={{ textAlign: "center" }}>
            <Field
              as="select"
              className="form-control"
              name={`govtPacCourses[${index}].afflType`}
              value={row?.affl_type === null ? null : row?.affl_type}
            >
              <option value="">--Select--</option>
              <option value="Provisional">Provisional</option>
              <option value="Permanent">Permanent</option>
              <option value="Conditional">Conditional</option>
              <option value="Temporary">Temporary</option>
            </Field>
            <ErrorMessage
              name={`govtPacCourses[${index}].afflType`}
              component="div"
              className="text-error"
            />
          </div>
        );
      },
    },
    {
      Header: "Sanctioned Intake",
      accessor: "final_sanction_intake",
    },
  ];
  const ReportColumns = [
    {
      Header: "Sl.no",
      accessor: (row, index) => index + 1,
    },
    {
      Header: "College Code",
      accessor: "coll_code",
    },
    {
      Header: "	College Name",
      accessor: "inst_name",
    },
    {
      Header: "Courses",
      accessor: "?column?",
      Cell: ({ cell: { value } }) => (
        <ul className="text-left">
          {value
            ?.split("<li>")
            .slice(1)
            .map((course, idx) => (
              <li key={idx}>
                {course.replace(/<\/?ol>|<\/?li>/g, "").trim()}
              </li>
            ))}
        </ul>
      ),
    },

  ]
  function backtocourses() {
    setshowcourses(true);
    setcourseeerrmsg(false);
    setshowconfirm(false);
    setconfirmerrmsg(false);
    setshowreport(false)
    setreporterrmsg(false)
    SetConfirmDetails([])
  }
  const dynamicHeader = showcourses
    ? "Govt Affiliation Course Confirmation"
    : showconfirm
      ? header
      : showreport ?
        header : ""

  return (
    <>
      <CommonFormHeading heading={dynamicHeader} />

      <bie.Container
        className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5"
      >
        <FormikProvider value={Courseaddingformik}>
          <Form
            onChange={Courseaddingformik.handleChange}
            onSubmit={Courseaddingformik.handleSubmit}
            className="form_adjust"
          >
            <bie.Row
              className="px-2 pt-3 mb-3"
            >
              <div className="table-responsive">
                {showcourses ? (
                  <>
                    {CourseDetails?.length > 0 ? (
                      <>
                        <CommonReactTable
                          data={CourseDetails}
                          columns={CourseColumns}
                          paginationCount="All"
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <>
                    {courseeerrmsg === true && (
                      <center className="text-danger h6">
                        *** No Data Found ***
                      </center>
                    )}
                  </>
                )}
                {/* second table */}

                <div>
                  {showconfirm && fieldsdata?.length > 0 ? (
                    <>
                      <bie.Row className="mb-3">
                        <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                          <button
                            type="button"
                            className="btn btn-sm btn-secondary"
                            style={{ float: "right" }}
                            onClick={backtocourses}>
                            Back
                          </button>
                        </bie.Col>
                      </bie.Row>

                      <bie.Row>

                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                          <label className="field-mandatory">
                            College Address :
                          </label>
                          <Field
                            as="textarea"
                            name="instAddress"
                            maxLength={350}
                            className="form-control"
                          />
                          <ErrorMessage
                            name="instAddress"
                            component="div"
                            className="text-error"
                          />
                        </bie.Col>
                        <bie.Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className="mb-2"
                        >
                          <label className="field-mandatory">
                            District :
                          </label>
                          <Field
                            as="select"
                            name="instDistCode"
                            className="form-control"
                          >
                            <option value="">--SELECT--</option>
                            {districtmst &&
                              districtmst.map((dd, i) => (
                                <option value={dd?.dist_code} key={i}>
                                  {dd?.dist_name}
                                </option>
                              ))}
                          </Field>
                          <ErrorMessage
                            name="instDistCode"
                            component="div"
                            className="text-error"
                          />
                        </bie.Col>
                        <bie.Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className="mb-2"
                        >
                          <label className="field-mandatory">
                            Category of the College :
                          </label>
                          <Field
                            as="select"
                            name="instStatus"
                            className="form-control"
                          >
                            <option value="">---select---</option>
                            <option value="Co-Education">Co-Education</option>
                            <option value="Women">Women</option>
                            <option value="Men">Men</option>
                          </Field>
                          <ErrorMessage
                            name="instStatus"
                            component="div"
                            className="text-error"
                          />
                        </bie.Col>

                        <bie.Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className="mb-2"
                        >
                          <label className="field-mandatory">
                            Having Minority Status :
                          </label>
                          <Field
                            as="select"
                            name="instMinority"
                            className="form-control"
                          >
                            <option value="">---select---</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Field>
                          <ErrorMessage
                            name="instMinority"
                            component="div"
                            className="text-error"
                          />
                        </bie.Col>
                      </bie.Row>
                    </>
                  ) : (
                    <></>
                  )}
                </div>

                {showconfirm ? (
                  <>

                    {ConfirmDetails?.length > 0 ? (
                      <>
                        <CommonReactTable data={ConfirmDetails} columns={ConformColumns} excelFlag={false} printFlag={false} paginationCount="All" />

                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <>
                    {confirmerrmsg === true && (
                      <bie.Row className="mb-3">
                        <bie.Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={11}
                          xl={11}
                          xxl={11}
                        >
                          <button
                            type="button"
                            className="btn btn-sm btn-secondary"
                            style={{ float: "right" }}
                            onClick={backtocourses}
                          >
                            Back
                          </button>
                        </bie.Col>
                        <bie.Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={1}
                          xl={1}
                          xxl={1}
                        >


                          <center className="text-danger h6">
                            *** No Data Found ***
                          </center>
                        </bie.Col>
                      </bie.Row>
                    )}
                  </>
                )}
                {showreport ? (
                  <>
                    <bie.Row className="mb-3">
                      <bie.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        xxl={12}
                      >
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary"
                          style={{ float: "right" }}
                          onClick={backtocourses}
                        >
                          Back
                        </button>
                      </bie.Col>
                    </bie.Row>
                    {ReportDetails?.length > 0 ? (
                      <>
                        <CommonReactTable
                          data={ReportDetails}
                          columns={ReportColumns}
                          paginationCount="All"
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <>
                    {reporterrmsg === true && (

                      <center className="text-danger h6">
                        *** No Data Found ***
                      </center>

                    )}
                  </>
                )}
              </div>
              {showconfirm && (
                isAlreadySubmitted ? (
                  <div className="pt-1 mb-5">
                    <p className="text-success text-end mb-2">Already Submitted.</p>
                  </div>
                ) : (
                  <div className="pt-1 mb-5">
                    <button
                      type="submit"
                      className="btn btn-success btn-sm float-end rounded mb-2"
                    >
                      Submit
                    </button>
                  </div>
                )
              )}
            </bie.Row>
          </Form>
        </FormikProvider>
      </bie.Container>
    </>
  );
};

export default AfflGovt_CourseAdding;
